export default __webpack_public_path__ + "static/media/webhook-dark.0479672f.svg";